<div class="parts-usage-container" *transloco="let t; prefix: 'parts.usage'">
  <!-- Filters -->
  <div class="filter-container pb-3 d-flex w-100 justify-content-between gap-2">
    <div class="search-wrapper">
      <app-search
        [placeholder]="t('search.placeholder')"
        [disabled]="isLoading"
        (searchTermUpdated)="onSearchTermUpdate($event)"
        customWidth="480px">
      </app-search>
    </div>

    <div class="filters-wrapper d-flex gap-2">
      <!-- Status Filter -->
      <span ngbDropdown class="filter-dropdown" [autoClose]="true">
        <button
          type="button"
          class="btn status-filter form-control dropdown-toggle filter-input"
          [disabled]="isLoading"
          id="statusFilterDropdown"
          ngbDropdownToggle>
          <div class="d-flex flex-row justify-content-between align-items-center">
            <span class="align-middle">{{ getStatusLabel(selectedStatus) }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>
        <div ngbDropdownMenu aria-labelledby="statusFilterDropdown" class="dropdown-menu-custom">
          @for (status of statusOptions; track $index) {
            <button class="btn btn-outline dropdown-item-custom" (click)="onStatusFilterChange(status)" ngbDropdownItem>
              {{ getStatusLabel(status) }}
            </button>
          }
        </div>
      </span>
    </div>
  </div>

  <!-- Table -->
  <div class="main-table parts-usage-overview">
    <table class="table">
      <thead>
        <tr>
          <th class="date" appSortHeader="date" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.date') }}</th>
          <th class="user" appSortHeader="user" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.user') }}</th>
          <th class="qty-requested" appSortHeader="quantityRequested" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.qtyRequested') }}</th>
          <th class="returned" appSortHeader="quantityReturned" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.returned') }}</th>
          <th class="on-hand" appSortHeader="onHand" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.onHand') }}</th>
          <th class="oem-parts-number" appSortHeader="partNumber" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.oemPartsNumber') }}</th>
          <th class="description" appSortHeader="description" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.description') }}</th>
          <th class="category" appSortHeader="category" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.category') }}</th>
          <th class="status" appSortHeader="status" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.status') }}</th>
          <th class="reason" appSortHeader="workOrderNumber" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.reason') }}</th>
          <th class="notes">{{ t('table.notes') }}</th>
        </tr>
      </thead>
      @if (isLoading) {
        <tbody>
          <tr class="loading-state-row">
            <td colspan="11">
              <div class="spinner-container">
                <div class="spinner-border" role="status"></div>
              </div>
            </td>
          </tr>
        </tbody>
      } @else {
        <tbody>
          @if (filteredItems.length > 0) {
            @for (item of filteredItems; track item.requestId) {
              <tr>
                <td class="date">
                  <p>{{ item.date | date:'dd/MM/yyyy' }}</p>
                </td>
                <td class="user">
                  <p [ngbTooltip]="getUserTooltip(item.user)" placement="auto" triggers="hover">{{ item.user }}</p>
                </td>
                <td class="qty-requested">
                  <p>{{ item.quantityRequested }}</p>
                </td>
                <td class="returned">
                  <p>{{ item.quantityReturned }}</p>
                </td>
                <td class="on-hand">
                  <p [class.highlight-orange]="item.status === 'Issued' && item.onHand === item.quantityRequested">
                    {{ item.onHand }}
                  </p>
                </td>
                <td class="oem-parts-number">
                  <p [ngbTooltip]="getPartNumberTooltip(item.partNumber)" placement="auto" triggers="hover">{{ item.partNumber }}</p>
                </td>
                <td class="description">
                  <p [ngbTooltip]="getPartNameTooltip(item.description)" placement="auto" triggers="hover">{{ getDescriptionText(item.description) }}</p>
                </td>
                <td class="category">
                  <p [ngbTooltip]="getCategoryTooltip(item.category)" placement="auto" triggers="hover">{{ item.category }}</p>
                </td>
                <td class="status">
                  <span class="status-badge" [ngClass]="getStatusClass(item.status)">
                    @if (item.status === PartsUsageItemStatus.Issued) {
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM6.66603 10.9407L4.1907 8.4707L5.13203 7.5267L6.6647 9.0567L10.194 5.52736L11.1367 6.47003L6.66603 10.9407Z"
                          fill="#50AD41" />
                      </svg>
                    } @else {
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM8.862 9.80467L6 6.94267V2.66667H7.33333V6.39067L9.80467 8.862L8.862 9.80467Z"
                          fill="#3873C9" />
                      </svg>
                    }
                    {{ getItemStatusLabel(item.status) }}
                  </span>
                </td>
                <td class="reason">
                  <p [ngbTooltip]="item.workOrderNumber" placement="auto" triggers="hover">{{ item.workOrderNumber }}</p>
                </td>
                <td class="notes">
                  @if (!item.hasNotes) {
                    <button class="note-btn" (click)="onNotesClick(item, $event)" [title]="t('actions.addNote')">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 11H13V5H11V11H5V13H11V19H13V13H19V11Z" fill="#9FA1A4" />
                      </svg>
                    </button>
                  } @else {
                    <button class="note-btn" (click)="onNotesClick(item, $event)" [title]="t('actions.viewNotes')">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 9C10.358 9 9 10.359 9 12C9 13.642 10.358 15 12 15C13.641 15 15 13.642 15 12C15 10.359 13.641 9 12 9Z" fill="#9FA1A4" />
                        <path d="M11.9993 5C4.36631 5 2.07231 11.617 2.05131 11.684L1.94531 12L2.05031 12.316C2.07231 12.383 4.36631 19 11.9993 19C19.6323 19 21.9263 12.383 21.9473 12.316L22.0533 12L21.9483 11.684C21.9263 11.617 19.6323 5 11.9993 5ZM11.9993 17C6.64831 17 4.57531 13.154 4.07331 12C4.57731 10.842 6.65131 7 11.9993 7C17.3503 7 19.4233 10.846 19.9253 12C19.4213 13.158 17.3473 17 11.9993 17Z" fill="#9FA1A4" />
                      </svg>
                    </button>
                  }
                </td>
              </tr>
            }
          }

          @if (hasError && filteredItems.length === 0) {
            <tr class="error-state-row">
              <td colspan="11">
                <div class="table__error">
                  <app-error-state></app-error-state>
                </div>
              </td>
            </tr>
          } @else if (filteredItems.length === 0) {
            <tr class="empty-state-row">
              <td colspan="11">
                <div class="table__no-data">
                  <app-empty-state></app-empty-state>
                </div>
              </td>
            </tr>
          }
        </tbody>
      }
    </table>
  </div>

  <!-- Pagination Footer -->
  <div class="bottom-options d-flex justify-content-between align-items-center">
    <div class="showing-text">{{ getShowingText() }}</div>

    <app-pagination [totalPages]="totalPages" [currentPage]="currentPage" (pageChange)="onPageChange($event)"> </app-pagination>

    <app-export
      [request]="getExportRequest()"
      [disabled]="isLoading"
      [filePrefix]="'PartsUsage'"
      [endpoint]="'parts/parts-usage'">
    </app-export>
  </div>
</div>